export const dineroFinanceColumns = [
    { id: "AccountNumber", label: "Account Number" },
    {id:"AccountName", label:"Account Name"},
    {id:"Date", label:"Date"},
    {id:"VoucherNumber", label:"Voucher Number"},
    {id:"VoucherType", label:"Voucher Type"},
    {id:"Description", label:"Description"},
    {id:"ContactName", label:"Contact Name"},
    // {id:"ContactNumber", label:"Contact Number"},
    {id:'ContactGuid', label:'Contact Guid'},
    {id:"VatType", label:"VAT Type"},
    {id:"VatCode", label:"VAT Code"},
    {id:"Amount", label:"Amount"},
    {id:"Type", label:"Type"},
  ];